import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class FeltoltesAdatlapDto extends IdentifiableDto {
	constructor() {
		super();
		this.csomagNev = null;
		this.adatlapFilename = null;
		this.adatlapPath = null;
		this.vizsgaAdatlap = null;
	}

	setup(props) {
		super.setup(props);
		this.csomagNev = props.csomagNev;
		this.adatlapFilename = props.adatlapFilename;
		this.adatlapPath = props.adatlapPath;
		this.vizsgaAdatlap = props.vizsgaAdatlap;
		return this;
	}
}

export default FeltoltesAdatlapDto;
